import Swiper from "swiper";
import { Navigation } from "swiper/modules";
import "swiper/css";

export function initWooFilters() {
  const filterSwiper = document.querySelector(".woo-filters__swiper");

  if (filterSwiper) {
    const filterContainer = document.querySelector(".woo-filters");
    const ajaxUrl = filterContainer?.dataset.ajaxUrl || "";

    // Initialize Swiper
    new Swiper(filterSwiper, {
      modules: [Navigation],
      slidesPerView: 2.5,
      spaceBetween: 15,
      speed: 800,
      loop: false,
      slideClass: "woo-filters__swiper-slide",
      navigation: {
        prevEl: filterContainer.querySelector(".woo-filters__btn-prev"),
        nextEl: filterContainer.querySelector(".woo-filters__btn-next"),
      },
      breakpoints: {
        576: { slidesPerView: 3 },
        768: { slidesPerView: 5.5 },
        1200: { slidesPerView: 7, spaceBetween: 20 },
        1500: { slidesPerView: 8 },
      },
    });

    // Update grid and result count
    const updateProductsDisplay = (data) => {
      if (data.success) {
        const gridContainer = document.querySelector(".woo-archive__grid");
        if (gridContainer) {
          if (data.data.data.includes("No products found")) {
            gridContainer.innerHTML = '<div class="no-products-title">Δεν βρέθηκαν προϊόντα</div>';
          } else {
            gridContainer.innerHTML = data.data.data;
            // window.lazyLoadInstance.update();
          }
        }

        const resultCount = document.querySelector(".woocommerce-result-count");
        if (resultCount) {
          const count = data.data.count || 0;
          resultCount.innerHTML = count + " " + (count === 1 ? "ΠΡΟΪΟΝ" : "ΠΡΟΪΟΝΤΑ");
        }
      }
    };

    // Handle filter button clicks
    const filterButtons = document.querySelectorAll(".filter-item");
    const resetButton = document.querySelector(".woo-filters__reset");

    filterButtons.forEach((button) => {
      button.addEventListener("click", function (e) {
        e.preventDefault();

        const categorySlug = this.dataset.categorySlug;

        // Remove active class from all buttons
        filterButtons.forEach((btn) => btn.classList.remove("active"));

        // Add active class to clicked button
        this.classList.add("active");

        // Show reset button
        if (resetButton) {
          resetButton.style.display = "inline-flex";
        }

        // AJAX request to filter products
        const formData = new FormData();
        formData.append("action", "woo_filter_products");
        formData.append("category_slug", categorySlug);

        fetch(ajaxUrl, {
          method: "POST",
          body: formData,
        })
          .then((response) => response.json())
          .then((data) => {
            updateProductsDisplay(data);
            // Dispatch custom event so LoadMoreProducts knows filter changed
            window.dispatchEvent(
              new CustomEvent("woo-filter-changed", {
                detail: {
                  categorySlug: categorySlug,
                  maxPages: data.data.max || 1,
                },
              }),
            );
          })
          .catch((error) => {
            console.error("AJAX Error:", error);
          });
      });
    });

    // Handle reset button click
    if (resetButton) {
      const parentSlug = filterContainer?.dataset.parentSlug || "";

      resetButton.addEventListener("click", function (e) {
        e.preventDefault();

        // Remove active class from all buttons
        filterButtons.forEach((btn) => btn.classList.remove("active"));

        // Hide reset button
        resetButton.style.display = "none";

        // Fetch parent category products
        const formData = new FormData();
        formData.append("action", "woo_filter_products");
        formData.append("category_slug", parentSlug);

        fetch(ajaxUrl, {
          method: "POST",
          body: formData,
        })
          .then((response) => response.json())
          .then((data) => {
            updateProductsDisplay(data);
            // Dispatch custom event so LoadMoreProducts knows filter was reset
            window.dispatchEvent(
              new CustomEvent("woo-filter-changed", {
                detail: {
                  categorySlug: parentSlug,
                  maxPages: data.data.max || 1,
                },
              }),
            );
          })
          .catch((error) => {
            console.error("Reset AJAX Error:", error);
          });
      });

      // Hide reset button initially if no filters are active
      const hasActiveFilter = Array.from(filterButtons).some((btn) => btn.classList.contains("active"));
      if (!hasActiveFilter) {
        resetButton.style.display = "none";
      }
    }
  }
}
